import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/chevron-down.svg'
import _imports_2 from '@/assets/icons/plus.svg'


const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = { class: "container py-8" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "flex flex-row justify-between items-center mb-4" }
const _hoisted_6 = { class: "flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = { class: "flex flex-row items-center mr-3" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = { class: "mr-4 capitalize" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "absolute top-0 right-0 flex flex-col bg-white rounded mt-8 w-48 shadow"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "capitalize" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Add new reimbursement")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_PendingReimbursement = _resolveComponent("PendingReimbursement")!
  const _component_ApprovedReimbursement = _resolveComponent("ApprovedReimbursement")!
  const _component_DeniedReimbursement = _resolveComponent("DeniedReimbursement")!
  const _component_ModalReimbursements = _resolveComponent("ModalReimbursements")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Navbar),
      _createElementVNode("div", {
        class: "flex-grow bg-background shadow-inner",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeDropdown($event)))
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.error)
                  ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _hoisted_7,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterSearch && _ctx.filterSearch(...args))),
                            type: "text",
                            placeholder: "Start typing to search reimbursements...",
                            class: "apperance-none border-0 rounded bg-background p-4 w-96 focus:outline-none focus:ring-0"
                          }, null, 544), [
                            [_vModelText, _ctx.searchQuery]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("button", {
                              class: "mr-8",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFilter = !_ctx.openFilter))
                            }, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedFilter.replaceAll("_", " ")), 1),
                                _hoisted_12
                              ])
                            ]),
                            (_ctx.openFilter)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item, i) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: i,
                                      class: "hover:bg-background-secondary rounded p-4 capitalize",
                                      onClick: ($event: any) => (_ctx.filterReimbursements(item))
                                    }, [
                                      _createElementVNode("span", _hoisted_15, _toDisplayString(item.replaceAll("_", " ")), 1)
                                    ], 8, _hoisted_14))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal = true)),
                            class: "btn-filled-sm"
                          }, _hoisted_17)
                        ])
                      ]),
                      (_ctx.allReimbursements.length === 0)
                        ? (_openBlock(), _createBlock(_component_EmptyState, {
                            key: 0,
                            name: "reimbursements"
                          }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            (_ctx.pending.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pending, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_PendingReimbursement, {
                                      key: i,
                                      reimbursement: item,
                                      nextUnlockedPayroll: _ctx.nextUnlockedPayroll
                                    }, null, 8, ["reimbursement", "nextUnlockedPayroll"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.approved.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approved, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_ApprovedReimbursement, {
                                      key: i,
                                      reimbursement: item
                                    }, null, 8, ["reimbursement"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.denied.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.denied, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_DeniedReimbursement, {
                                      key: i,
                                      reimbursement: item
                                    }, null, 8, ["reimbursement"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]))
              ]))
        ])
      ])
    ]),
    _createVNode(_component_ModalReimbursements, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.openModal) = $event))
    }, null, 8, ["openModal"])
  ]))
}